import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ImageCroppedEvent, ImageTransform } from "ngx-image-cropper";

import { LorenImageCropperData } from "../../interfaces/loren-image-cropper-data.interface";
import { LorenBreakpointObserverService } from "../../../../services/loren-breakpoint-observer-service/loren-breakpoint-observer.service";

@Component({
    selector: "loren-image-cropper-dialog",
    templateUrl: "./loren-image-cropper-dialog.component.html",
    styleUrls: ["./loren-image-cropper-dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenImageCropperDialogComponent implements OnInit {
  private data = inject<LorenImageCropperData>(MAT_DIALOG_DATA);
  private lorenBreakpointObserverService = inject(LorenBreakpointObserverService);

  srcImage: string;
  croppedImage: string;
  isHandset$ =
    this.lorenBreakpointObserverService.getHandsetStateSubscription();
  loading: boolean;
  imageTransform: ImageTransform = {};
  scale = 1;
  lastSliderValue = 1;

  ngOnInit(): void {
    this.loading = true;
    this.srcImage = this.data.sourceImage;
  }

  zoomChange(event: Event): void {
    const value = Number((event.target as HTMLInputElement).value);
    const scaleChange = (this.scale += (value - this.lastSliderValue) * 0.1);
    this.imageTransform = {
      ...this.imageTransform,
      scale: scaleChange,
    };

    this.lastSliderValue = value;
  }

  save(): void {
    this.data.croppedImage = this.croppedImage;
  }

  async imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = await this.blobToBase64(event.blob);
  // this.croppedImage = event.base64;
  }

  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event: ProgressEvent<FileReader>) => {
        if (event.target?.result) {
          resolve(event.target?.result as string);
        } else {
          reject(new Error('Error reading blob'));
        }
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(blob);
    });
  }
}
